export default __webpack_public_path__ + "static/graph-mobile-2d1c98e8f42bda4e02acf0d952b45296.png";